import { render, staticRenderFns } from "./paymentSettingsIndex.pug?vue&type=template&id=53a8b628&lang=pug&"
import script from "./paymentSettingsIndex.ts?vue&type=script&lang=ts&"
export * from "./paymentSettingsIndex.ts?vue&type=script&lang=ts&"
import style0 from "./paymentSettingsIndex.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports